import { useQueryClient } from 'react-query';
import { QueryFilters } from 'react-query/types/core/utils';

export const useIsSuccessful = (filters: QueryFilters): boolean => {
  const { queryKey, ...otherFilters } = filters;
  const queryClient = useQueryClient();

  const state = queryClient.getQueryState(queryKey || [], otherFilters);

  return state?.status === 'success';
};
